export interface ContentItem {
  title: string;
  subtitle: string;
}

export interface JobsContentItem extends ContentItem {
  searchLink: string;
}

export interface CandidatesContentItem extends ContentItem {
  newCandidatesLink: string;
}

export interface JobPostingsContentItem extends ContentItem {
  createLink: string;
}

export interface Content {
  notifications: ContentItem;
}

export interface EmployerContent extends Content {
  jobs: JobsContentItem;
  candidates: CandidatesContentItem;
}

export interface RecruiterContent extends Content {
  jobPostings: JobPostingsContentItem;
  applicants: ContentItem;
}

export const RECRUITERS: EmployerContent = {
  notifications: {
    title: 'Notifications',
    subtitle: 'You don’t have any notifications yet.',
  },
  jobs: {
    title: 'Jobs',
    subtitle: 'You don’t have any jobs yet.\nView openings now',
    searchLink: 'View job openings',
  },
  candidates: {
    title: 'Candidates',
    subtitle:
      "You don't have any new candidates for review yet.\nOnce a candidate will apply via shareable link you will see his profile for review",
    newCandidatesLink: 'Review New Candidates',
  },
};

export const EMPLOYERS: RecruiterContent = {
  notifications: {
    title: 'Notifications',
    subtitle: 'You don’t have any notifications yet.',
  },
  jobPostings: {
    title: 'Job Postings',
    subtitle: 'You don’t have a job posting yet.\nClick below to create one.',
    createLink: 'Create a job posting',
  },
  applicants: {
    title: 'Applicants',
    subtitle: 'You don’t have an applicant yet.',
  },
};
